import React from 'react';

export const MonitorScreen = ({
  color,
  width,
  height,
  top,
  left
}: {
  color?: string;
  width?: string;
  height?: string;
  top?: string;
  left?: string;
}): JSX.Element => {
  const className = 'icon icon--monitor-screen';
  color = color || '#2C3E50';
  width = width || '25';
  height = height || '24';
  top = top || '0';
  left = left || '0';

  return (
    <svg
      width={width}
      height={height}
      viewBox={`${left} ${top} ${width} ${height}`} //"2 3 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...{ className }}
    >
      <g clipPath="url(#clip0_12961_3374)">
        <path
          d="M3.313 4C3.313 3.73478 3.41836 3.48043 3.6059 3.29289C3.79343 3.10536 4.04779 3 4.313 3H20.313C20.5782 3 20.8326 3.10536 21.0201 3.29289C21.2076 3.48043 21.313 3.73478 21.313 4V16C21.313 16.2652 21.2076 16.5196 21.0201 16.7071C20.8326 16.8946 20.5782 17 20.313 17H4.313C4.04779 17 3.79343 16.8946 3.6059 16.7071C3.41836 16.5196 3.313 16.2652 3.313 16V4Z"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M3.313 13H21.313" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
        <path d="M8.313 21H16.313" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
        <path d="M10.313 17L9.813 21" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
        <path
          d="M14.313 17L14.813 21"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_12961_3374">
          <rect width={width} height={height} fill="white" transform="translate(0.313004)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default MonitorScreen;
